import _ from 'lodash';

export default {
  activeInteraction: state => state.activeInteraction,
  activeInteractionGroup: (state, getters) => _.filter(getters.interactionStates, is => is.interactionMeta.inDisplayRange),
  activeInteractionMeta: (state, getters) => {
    // NOT USED ANYWHERE
    if (!state.activeInteraction) return null;
    else return _.find(state.interactionMetas, im => im.interactionId === state.activeInteraction.id);
  },
  activeOverlayInteractions: (state, getters) =>  _.filter(getters.interactionStates, (is) => (is.interactionMeta.overlay && is.interactionMeta.inDisplayRange && !is.interactionMeta.hiddenByRequired)),
  activeSidebarGroup(state, getters) {
    return _.filter(getters.activeInteractionGroup, aig => !aig.interactionMeta.overlay && !aig.interactionMeta.hiddenByRequired);
  },
  discussionComments: state => (interactionId) => {
    return state.discussionComments[interactionId];
  },
  userSubmittedDiscussionComment: (state) => (interactionId, userId) => {
    // This could be a reference to a 'root' comment, or reply comment
    const userHasRootComments = state?.discussionComments[interactionId]?.filter(
      (userComment) => userComment?.userId === userId)?.length > 0;
    let userHasReplyComments = false;
    for (const rootComment of (state?.discussionComments[interactionId]?.filter((comment) => comment?.replies?.length > 0) || [])) {
      // check to see for the root comment that has replies, if any are from the userId
      userHasReplyComments = rootComment?.replies?.some((replyComment) => replyComment?.userId === userId);
      if (userHasReplyComments) break;
    };
    return (userHasRootComments || userHasReplyComments);
  },
  oldDiscussionComments: state => state.oldDiscussionComments,
  icons: state => { // interaction type mapped to material icon name
    return {
      multiple_choice: 'format_list_bulleted',
      check_all_apply: 'playlist_add_check',
      free_response: 'border_color',
      skip_to: 'content_cut',
      short_answer: 'subtitles',
      pause_q: 'bookmark_border',
      iframe_q: 'public',
      file_viewer_q: 'picture_as_pdf',
      poll_q: 'poll',
      discussion_q: 'chat',
      default: 'pets',
      info: 'info',
      secondary_stream: "ondemand_video",
    }
  },
  types (state, getters) { // interaction type mapped to text description of interaction type
    return {
      multiple_choice: 'Multiple Choice',
      check_all_apply: 'Check All',
      free_response: 'Free Response',
      skip_to: 'Skip Ahead',
      short_answer: 'Fill Blank',
      pause_q: 'Reflective Pause',
      iframe_q: 'Web Embed',
      file_viewer_q: 'PDF File',
      poll_q: 'Polling Survey',
      discussion_q: 'Discussion Forum',
      defaults: 'defaults', // default interactions will not be displayed but here for backup
      info: 'info',
      secondary_stream: "Secondary Stream",
    }
  },
  incompleteHotspots(state, getters) {
    return _.filter(getters.activeInteractionGroup, is => is.interactionMeta.overlay && is.interaction.pause && is.interactionMeta.inDisplayRange && !is.interactionMeta.isInteractionAnswered).length;
  },
  incompleteSidebar(state, getters) {
    return _.filter(getters.activeInteractionGroup, is => !is.interactionMeta.overlay && is.interaction.pause && is.interactionMeta.inDisplayRange && !is.interactionMeta.isInteractionAnswered).length;
  },
  interactions: state => _.sortBy(state.interactions, ['displayInTime', 'id']),
  interactionAttempts: state => state.interactionAttempts,
  interactionMetas: state => state.interactionMetas,
  interaction: (state, getters) => (interactionId) => {
    return getters.interactions.find(i => i.id === interactionId);
  },
  interactionAttempt: (state, getters) => (interactionId) => getters.interactionAttempts.find(ia => ia.interactionId === interactionId),
  interactionMeta: state => (interactionId) => state.interactionMetas.find(im => im.interactionId === interactionId),
  concurrentInteractions: state => state.concurrentInteractions,
  rubricInteractions: (state, getters, rootState) => {
    return _.chain(_.get(rootState, 'player.bulb.banks[0].interactions'))
            .filter((i) => i.config.template_key === 'rubric')
            .orderBy(i => i.interactionBank.order, ['asc'])
            .value();
  },
  rubricSubmitting: state => state.rubricSubmitting,
  rubricSubmitted: state => state.rubricSubmitted,
  sidebarInteractions: (state, getters) => {
    return _.filter(getters.interactions, (i) => {
      // console.log(i.id, getters.interactionMetas);
      let im = getters.interactionMeta(i.id);
      if (!im || im.rubric) return false;
      return !im.overlay
    }) || [];
  },
  overlayInteractions: (state, getters) => {
    return _.filter(getters.interactions, i => {
      let im = getters.interactionMeta(i.id);
      if (!im || i.rubric) return false;
      return im.overlay
    }) || [];
  },
  interactionGroups: (state, getters) => state.interactionGroups,
  requiredInteractionIndex: (state, getters) => _.findIndex(getters.interactionStates, is => is.interaction.isRequired && !is.interactionMeta.isInteractionAnswered && !is.interactionMeta.rubric),
  interactionStates(state, getters, rootState, rootGetters) {
    if (!rootGetters['player/hasNewInteractionDisplayAccess']) { // use old interactionStates getter logic.
      let interactionStates = [];
      if (getters.interactions) {
        getters.interactions.forEach(interaction => {
          interactionStates.push({
            interaction: _.assign({}, _.cloneDeep(state.defaultInteraction), _.find(getters.interactions, i => i.id === interaction.id) || {}),
            interactionAttempt: _.assign({}, _.cloneDeep(state.defaultInteractionAttempt), _.find(getters.interactionAttempts, ia => ia.interactionId === interaction.id) || {}),
            interactionMeta: _.assign({}, _.cloneDeep(state.defaultInteractionMeta), _.find(getters.interactionMetas, im => im.interactionId === interaction.id) || {})
          });
        });
      }
      return _.sortBy(interactionStates, is => is.interaction.displayInTime);
    } else {
      return state.interactionStates; // using newer interaction display logic that uses mutations
    }
  },
  interactionStateById(state, getters) {
    // NOT USED ANYWHERE
    return interactionId => {
      return {
        interaction: _.assign({}, _.cloneDeep(state.defaultInteraction), _.find(getters.interactions, i => i.id === interactionId) || {}),
        interactionAttempt: _.assign({}, _.cloneDeep(state.defaultInteractionAttempt), _.find(getters.interactionAttempts, ia => ia.interactionId === interactionId) || {}),
        interactionMeta: _.assign({}, _.cloneDeep(state.defaultInteractionMeta), _.find(getters.interactionMetas, im => im.interactionId === interactionId) || {}),
      };
    };
  },
  hasRequiredInteractions: (state, getters, rootState, rootGetters) => {
    return _.filter(getters.interactionStates, (is) => {
      return (
        (
          !is.interactionMeta.isInteractionAnswered
          || rootState.player.isLiveSession
        )
        && is.interaction.isRequired
      );
    }).length > 0;
  },
  nextDisabled(state, getters) {
    if (!getters.activeInteraction) return true;
    return _.findIndex(getters.activeSidebarGroup, aig => aig.interaction.id === getters.activeInteraction.id) === getters.activeSidebarGroup.length - 1
  },
  previousDisabled(state, getters) {
    if (!getters.activeInteraction) return true
    return getters.activeSidebarGroup.length < 2 || _.findIndex(getters.activeSidebarGroup, aig => aig.interaction.id === getters.activeInteraction.id) === 0
  },
  continueAction: (state, getters) => ({ interactionMeta } ) => {
    if (interactionMeta.overlay) {
      return getters.incompleteHotspots > 0 ? 'next' : 'continue';
    }
    return (getters.incompleteSidebar > 0 && !getters.nextDisabled) ? 'next' : 'continue';
  },
}
